function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="15" height="15" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M13.41 6.071L15 7.637 7.5 15 .028 7.61l1.59-1.566L7.5 11.868l5.91-5.797zm1.562-4.505L13.382 0 7.5 5.824 1.59.027 0 1.593l7.5 7.363 7.472-7.39z" fill="#278C7E" /></svg>;
});